// extracted by mini-css-extract-plugin
export default {"container":"TextButton_container__AzO3-","label":"TextButton_label__eTXn7"};